<template>
<div class="filters">
  <v-container fluid>

      <v-row align="center">
        <!-- <v-col class="d-flex" cols="12" sm="4">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Selecionar intervalo de datas"
                prepend-icon="event"
                readonly
                v-on="on"
                class="input-datas"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4">
          <v-select
            :items="items"
            label="Produto"
            dense
          ></v-select>
        </v-col> -->

      <v-col class="d-flex" cols="12" sm="4">
        <v-select
          :items="estados"
          label="Estado"
          dense
          @change="updateFilter()"
          v-model="estado"
        ></v-select>
      </v-col>

    </v-row>
  </v-container>
  </div>
</template>

<script>
  export default {
    name:'FiltersLeads',
    props: [
      "estados"
    ],
    data: () => ({
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      date: [],
      menu: false,
      modal: false,
      menu2: false,
      estado: "All",
    }),
    computed: {
      dateRangeText () {
        return this.dates.join(' ~ ')
      },
    },
    methods: {
      updateFilter: async function() {
        this.$emit('change-estado', this.estado)
      }
    }
  }
</script>

<style scoped>
  .filters{
      margin: 20px 40px 0px 296px;
    }

    .input-datas{
      margin-top: -2px;
      font-size:14px;
    }
</style>